import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  tutorialDialogWasShown: false,
  tutorialDecorationScreenWasOpened: false,
  tutorialSlot: 7,
};

const { actions, reducer } = createSlice({
  name: 'decoration',

  initialState,

  reducers: {
    setTutorialDialogWasShown(decoration, { payload }: PayloadAction<boolean>) {
      decoration.tutorialDialogWasShown = payload;
    },
    setTutorialDecorationScreenWasOpened(
      decoration,
      { payload }: PayloadAction<boolean>,
    ) {
      decoration.tutorialDecorationScreenWasOpened = payload;
    },
    setTutorialSlot(decoration, { payload }: PayloadAction<number>) {
      decoration.tutorialSlot = payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase('RESET_APP', () => initialState);
  },
});

export const decorationsActions = actions;
export default reducer;
